import { styled } from '../../Styles/stitches.config'

export const StyledCard = styled('div', {
    alignItems: 'center',
    border: '1px solid $primary600',
    br: '$1',
    cursor: 'pointer',
    display: 'grid',
    justifyItems: 'center',
    overflow: 'hidden',
    transition: '$default',

    '&:hover': {
        boxShadow: '$default',
    },
})
